import Vue from "vue";
import Router from "vue-router";
import authenticationGuard from "@/auth/authenticationGuard";

Vue.use(Router);

function paramToInt(route) {
  const obj = route.params;
  Object.keys(route.params).forEach((e) => {
    if (e !== "folderId") {
      const num = Number.parseInt(route.params[e], 10);
      if (!Number.isNaN(num)) obj[e] = num;
    }
  });
  return obj;
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/403-Forbidden",
      meta: { layout: "error", error: { statusCode: 403 } },
    },
    {
      path: "/automation",
      beforeEnter: () => {
        window.open("https://automation.acelerex.com", "_self");
      },
    },
    {
      path: "/data-services",
      beforeEnter: () => {
        window.open("https://dataservices.acelerex.com", "_self");
      },
    },
    {
      path: "/portal",
      beforeEnter: () => {
        const url = `https://portal${
          process.env.NODE_ENV === "production" ? "" : ".staging"
        }.acelerex.com`;
        window.open(url, "_self");
      },
    },
    {
      path: "/wiki/:id?",
      name: "Wiki",
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "Wiki" */ "@/views/Wiki.vue"),
      // beforeEnter: () => {
      //   const url = `${window.location.protocol}//${window.location.host}/wiki/`;
      //   window.open(url, "_blank");
      // },
    },
    // {
    //   name: "ClassicHomepage",
    //   path: "/classic",
    //   meta: { requiresAuth: true },
    //   component: () => import(/* webpackChunkName: "Homepage" */ "@/views/Index.vue"),
    // },
    // {
    //   name: "ClassicFolders",
    //   path: "/classic/folders",
    //   meta: { requiresAuth: true },
    //   component: () => import(/* webpackChunkName: "Homepage" */ "@/views/Folders.vue"),
    // },
    // {
    //   name: "ClassicJobs",
    //   path: "/classic/jobs",
    //   meta: { requiresAuth: true },
    //   component: () => import(/* webpackChunkName: "Deltas" */ "@/views/JobOverview.vue"),
    // },
    // {
    //   name: "ClassicDeltas",
    //   path: "/classic/deltas",
    //   meta: { requiresAuth: true },
    //   component: () => import(/* webpackChunkName: "Deltas" */ "@/views/Deltas.vue"),
    // },
    // {
    //   name: "ClassicForecasts",
    //   path: "/classic/forecasts",
    //   meta: { requiresAuth: true },
    //   component: () => import(/* webpackChunkName: "IHR" */ "@/views/Forecasts.vue"),
    // },
    {
      path: "/",
      redirect: { name: "Home" },
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "Storage" */ "@/views/Storage.vue"),
      children: [
        {
          name: "Home",
          path: "home",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Home" */ "@/views/Index.vue"),
        },
        {
          name: "Folders",
          path: "folders/:folderId?",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Folders" */ "@/views/Folders.vue"),
        },
        {
          name: "Deltas",
          path: "deltas",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Folders" */ "@/views/Deltas.vue"),
        },
        {
          name: "Forecasts",
          path: "forecasts",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Folders" */ "@/views/Forecasts.vue"),
        },
        {
          name: "Jobs",
          path: "jobs",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Folders" */ "@/views/JobOverview.vue"),
        },
        {
          name: "RecycleBin",
          path: "recycle-bin",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "RecycleBin" */ "@/views/RecycleBin.vue"),
        },
      ],
    },
    {
      path: "/folders/:folderId?/case/:id",
      alias: "/case/:id",
      props: paramToInt,
      component: () => import(/* webpackChunkName: "Cases" */ "@/views/CaseView.vue"),
      children: [
        {
          name: "CaseInput",
          path: "input",
          alias: "",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Cases" */ "@/views/CaseInput.vue"),
        },
        {
          name: "CaseOutput",
          path: "output",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "CaseOutput" */ "@/views/CaseOutput.vue"),
        },
        {
          name: "CaseVis",
          path: "visualization",
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "CaseVis" */ "@/views/CaseVis.vue"),
        },
      ],
    },
    {
      name: "ReportView",
      path: "/reports",
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "ReportView" */ "@/views/reports/_id.vue"),
    },
    {
      name: "Docs",
      path: "/docs",
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "APIDoc" */ "@/views/APIDocumentation.vue"),
    },
    {
      name: "Releases",
      path: "/releases",
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "Releases" */ "@/views/Releases.vue"),
    },
    {
      name: "Login",
      path: "/login",
      meta: { requiresAuth: false },
      callback: false,
      home: false,
      component: () => import(/* webpackChunkName: "Login" */ "@/views/Login.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth) || to.name === "login") {
    authenticationGuard(to, from, next, router);
  } else {
    next();
  }
});

router.onError((e) => {
  if (e.name === "Forbidden") {
    router.push("/403-Forbidden");
  }
});

export default router;
